// @flow
import { getStateCurrentValue, getStateIsFilterActive, type State } from 'app/common/ui-components/filter';
import { productionTypes } from 'app/dataTypes/reports/productionTypes';

import { filterId } from './filterId';


export const filterActive = (state: State): boolean => {
  return getStateIsFilterActive(filterId, state);
};

export const onlyDishesSelected = (state: State) => {
  const productionTypeSelected = getStateCurrentValue(filterId, state);
  return (
    productionTypeSelected.length === 1
    && productionTypeSelected[0] === productionTypes.Dish
  );
};

export const onlyComplexeselected = (state: State) => {
  const productionTypeSelected = getStateCurrentValue(filterId, state);
  return (
    productionTypeSelected.length === 1
    && productionTypeSelected[0] === productionTypes.Complex
  );
};

export const allSelected = (state: State) => {
  const productionTypeSelected = getStateCurrentValue(filterId, state);
  return (
    productionTypeSelected.length === 0 || productionTypeSelected.length === 2
  );
};
